import React, { useState } from 'react'
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom'

export default function ForgetPassword() {
    const imageUrl = "./assets/images/";
    const { register, handleSubmit, reset, formState: { errors },
    } = useForm();
    const navigate = useNavigate()
    // show hide password
    const [password, showPassword] = useState(false);
    const showpassword = () => showPassword(!password);
    // login api
    const loginUser = async (data) => {
        navigate("/otp");
    };
    return (
        <div className="login-form">
            <div className="text-center mb-8">
                <h1 className='heading-color Sora_SB text-3xl mb-2'>Forgot Password?</h1>
                <p className='Sora_R opacity-80 text-sm'>Please enter your email Id</p>
            </div>
            <form onSubmit={handleSubmit(loginUser)}>
                <div class="mb-14">
                    <label class="block text-sm mb-2" for="username">
                        Email
                    </label>
                    <div className="flex input-box">
                        <input class="appearance-none  w-full focus:outline-none focus:shadow-outline" id="username"
                            type="text" placeholder="Username"  {...register("email", { required: true })} />
                        <span>@</span>
                    </div>
                    {errors.email && <span className="text-red-500 text-xs italic">This field is required</span>}
                </div>
                <div class="flex items-center justify-between ">
                    <button type="submit" class="btn w-full text-center">
                        Submit
                    </button>
                </div>
                <div className="w-full mt-8 justify-center flex items-center">
                    Back to
                    <Link class="inline-block align-baseline text-sm ps-1" to="/">
                        Login
                    </Link>
                </div>
            </form>
        </div >
    )
}
